import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const MaithriCulturalFest2026 = () => {
    const festImages = [
        "1000463319.jpg",
        "1000463334.jpg",
        "1000463337.jpg",
        "1000463346.jpg",
        "1000463533.jpg",
        "1000463278.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    
                                    <h2>
                                        Maithri Cultural Fest – Women’s Day & Ugadi Celebrations (March 17, 2026)
                                    </h2>

                                    <div className='py-2'>
                                        <p>
                                            <strong>Maithri</strong>, the cultural fest, was celebrated on <strong>17th March 2026</strong> along with <strong>Women’s Day</strong> and <strong>Ugadi</strong> celebrations, creating a vibrant and festive atmosphere across the campus.
                                        </p>

                                        <p>
                                            The event showcased a variety of cultural performances, highlighting the creativity, talent, and enthusiasm of students. The celebrations brought together traditional and modern elements, reflecting the spirit of unity and cultural diversity.
                                        </p>

                                        <p>
                                            The combined celebration of Women’s Day and Ugadi added special significance to the event, promoting empowerment, tradition, and new beginnings among students and faculty.
                                        </p>

                                        <p>
                                            The fest was a grand success, with active participation from students and support from faculty and management, making it a memorable and joyful occasion for everyone.
                                        </p>
                                    </div>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {festImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Cultural-fest-Maithri-and-Women_s-Day-celebrations/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Cultural-fest-Maithri-and-Women_s-Day-celebrations/${img}`}
                                                            alt={`Maithri Cultural Fest 2026 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default MaithriCulturalFest2026;